import { ClearRounded, EditRounded } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { API, controller } from "api";
import { Button } from "controls";
import { Alert, Dialog, Table } from "layout";
import { useContext, useEffect, useState } from "react";
import AddEditFollowUp from "./AddEditFollowUp";
import { formatDate } from "hooks";
import moment from "moment";
import { AppContext } from "App";

const InqFollowUps = ({ values }) => {
  const { access } = useContext(AppContext);
  const [followUps, setFollowUps] = useState([]);
  const [updData, setUpdData] = useState();
  const [showForm, setShowForm] = useState(false);
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    values.followUps.length && setFollowUps([...values.followUps]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  const handleAddEdit = (data) => {
    setUpdData(data);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: "Are you sure",
      subTitle: "You want to delete this follow-up?",
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: "Deleted Successfully",
              subTitle: res.msg,
            });
            setFollowUps((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else if (res) {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res.msg,
            });
          }
        };
        API(controller.FollowUp).Delete(id, onComplete);
      },
    });
  };

  const ActionComp = (val) =>
    access?.inquery?.followUpCUD && (
      <div className="bg-gray-50 w-fit flex gap-2 rounded-[10px] shadow-md">
        <Tooltip title="Edit">
          <IconButton
            onClick={() => handleAddEdit(val)}
            size="small"
            color="primary"
          >
            <EditRounded className="m-[2px] !text-[18px]" />
          </IconButton>
        </Tooltip>

        <Tooltip title="Delete">
          <IconButton
            onClick={() => handleDlt(val.id)}
            size="small"
            color="error"
          >
            <ClearRounded className="m-[2px] !text-[18px]" />
          </IconButton>
        </Tooltip>
      </div>
    );

  const HeaderComp = () => (
    <div>
      {access?.inquery?.followUpCUD && values.status === 1 && (
        <Button onClick={() => handleAddEdit()}>Add Follow Up</Button>
      )}
    </div>
  );

  return (
    <div>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "date", label: "Follow Up Date" },
          { id: "time", label: "Follow Up Time" },
          { id: "type", label: "Type" },
          { id: "note", label: "Note" },
          { id: "actions", label: "Actions" },
        ]}
        tblData={followUps.map((j) => ({
          ...j,
          type: j.followUpType && j.followUpType.name,
          date: formatDate(j.followUpDate, "DD MMMM, YYYY"),
          time: moment(j.followUpTime).format("hh:mm A"),
        }))}
      />

      {/* Add Follow Up */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="sm">
          <AddEditFollowUp
            {...{
              setShowForm,
              setAlert,
              inqData: values,
              setFollowUps,
              updData,
            }}
          />
        </Dialog>
      )}
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </div>
  );
};

export default InqFollowUps;
